import styles from './OrderSubtotal.module.scss';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { InlineLoader } from 'cat-ecommerce-alloy';
import { STATUS } from '@app/constants/commonConstants';
import BorderBottomDotted from '@app/components/common/BorderBottomDotted/BorderBottomDotted';
import { priceDisplayFormat } from '@app/utils/paymentUtils';

const OrderSubtotal = ({ isFromOrderSummary = false }) => {
  const orderTotals =
    useSelector(s => s.orders.byId[s.orders.current]?.orderTotals) || {};
  const {
    currencyNotation,
    isOrderSubtotalLoading,
    isOrderPriceAvailabilityLoading,
    isOrderSubtotalFailure,
    getCurrentOrderStatus,
    includeGST,
    showGST
  } = useSelector(s => s.orders);

  const { orderSubTotal, orderSubTotalWithGST } = orderTotals;
  const [t] = useTranslation();
  const isShoppingCartPage = () =>
    (window.location?.pathname || '').includes('/AjaxOrderItemDisplayView') ||
    (window.location?.pathname || '').includes('/AjaxCheckoutDisplayView');
  const finalOrderSubtotal =
    isShoppingCartPage() && includeGST && showGST
      ? orderSubTotalWithGST
      : orderSubTotal;
  const getCurrentOrderLoading =
    getCurrentOrderStatus === STATUS.IDLE ||
    getCurrentOrderStatus === STATUS.PENDING;

  const hasError = isOrderSubtotalFailure;
  const isLoading =
    isOrderSubtotalLoading ||
    getCurrentOrderLoading ||
    isOrderPriceAvailabilityLoading;

  const getOrderTotalErrorMessage = () => (
    <>
      <div
        className={cx(
          'd-flex justify-content-between justify-content-md-end d-print-none',
          {
            'py-2': !isFromOrderSummary
          },
          { 'pb-2': isFromOrderSummary }
        )}
      >
        {!isFromOrderSummary && (
          <div className={`${styles['subtotal__heading']} text-start m-0`}>
            {t('ORDER_SUBTOTAL')}
          </div>
        )}
        {isFromOrderSummary && isLoading && (
          <div
            className={cx(styles['subtotal__heading'], {
              [`${styles['floating-cart-subtotal__heading']}`]:
                isFromOrderSummary
            })}
          >
            {t('ORDER_SUBTOTAL')}
          </div>
        )}
        {isLoading ? (
          <div className="d-flex justify-content-center justify-content-md-end">
            <InlineLoader />
          </div>
        ) : (
          <div
            className={cx(
              {
                [`${styles['subtotal__value']}`]: !isFromOrderSummary
              },
              {
                [`${styles['subtotal__error']}`]: !isFromOrderSummary
              },
              {
                [`${styles['floating-cart-subtotal__error']}`]:
                  isFromOrderSummary
              }
            )}
          >
            {t('SUBTOTAL_ERROR')}
          </div>
        )}
      </div>
    </>
  );
  const getOrderSubtotals = () => {
    if (hasError) {
      return getOrderTotalErrorMessage();
    } else {
      return (
        <div
          className={cx(
            'd-flex',
            {
              'justify-content-between justify-content-md-end py-2':
                !isFromOrderSummary
            },
            { 'pb-2 mb-1': isFromOrderSummary }
          )}
        >
          <div
            className={cx({
              [`${styles['subtotal__heading']} d-print`]: !isFromOrderSummary,
              [`${styles['subtotal__value-summary']} flex-grow-1 text-start u-color--DarkGray text-univers--bold text-uppercase flex-wrap text-break`]:
                isFromOrderSummary
            })}
          >
            {t('ORDER_SUBTOTAL')}
          </div>
          {!isFromOrderSummary && (
            <BorderBottomDotted className={'d-none d-print-block mb-0'} />
          )}
          {isLoading ? (
            <div className="d-flex justify-content-center justify-content-md-end">
              <InlineLoader />
            </div>
          ) : (
            <div
              className={cx({
                [`${styles['subtotal__value']}`]: !isFromOrderSummary,
                [`${styles['subtotal__value-summary']} u-color--DarkGray text-univers--bold flex-wrap text-break`]:
                  isFromOrderSummary
              })}
            >
              {currencyNotation &&
                priceDisplayFormat({
                  price: finalOrderSubtotal,
                  currency: currencyNotation
                })}
            </div>
          )}
        </div>
      );
    }
  };

  return getOrderSubtotals();
};
export default OrderSubtotal;
